export default __webpack_public_path__ + "static/media/Vector.1d69ec84.svg";